export const DOMAIN_ACCOUNT_TYPES = [
  { value: "10", label: "Accounting Firm" },
  { value: "20", label: "Association" },
  { value: "30", label: "Bank" },
  { value: "40", label: "Benefits Enrollment" },
  { value: "50", label: "Broker Dealer" },
  { value: "60", label: "Credit Union" },
  { value: "70", label: "Email Service Provider" },
  { value: "80", label: "Financial Advisory" },
  { value: "90", label: "Health Care Provider" },
  { value: "100", label: "IMO" },
  { value: "110", label: "General Agency" },
  { value: "120", label: "Insurance Brokerage" },
  { value: "130", label: "Insurance Carrier" },
  { value: "140", label: "Investment Bank" },
  { value: "150", label: "Law Firm" },
  { value: "160", label: "Lead Generation Company" },
  { value: "170", label: "Provider" },
  { value: "180", label: "Miscellaneous" },
  { value: "190", label: "Mortgage Company" },
  { value: "200", label: "Online Insurance Brokerage" },
  { value: "210", label: "Out of Business" },
  { value: "210", label: "Outsourced Services" },
  { value: "220", label: "Payroll Processor" },
  { value: "230", label: "Real Estate Brokerage" },
  { value: "240", label: "Registered Investment Advisor" },
  { value: "250", label: "Settlement Broker" },
  { value: "260", label: "Structured Settlement Firm" },
  { value: "270", label: "Trust Company" },
  { value: "990", label: "Unknown" },
];

export let DOMAIN_ACCOUNT_TYPES_MAP = {};
for (const p of DOMAIN_ACCOUNT_TYPES) {
  DOMAIN_ACCOUNT_TYPES_MAP[p.value] = p.label;
}
